import React, { FC, useEffect } from 'react';
import MfDialog from '../UI/Dialog/MfDialog';
import SignAgentReportComponent from './SignAgentReportComponent';
import { AgentRequestResponse } from '../../structures/response/AgentRequestResponse';

interface Props {
  onClose: () => void;
  open: boolean;
  request: AgentRequestResponse | null;
}

const SignAgentReportDialog: FC<Props> = ({ onClose, open, request }) => {
  useEffect(() => {
    if (open && request?.report?.reportDocument?.isSigned === true) {
      onClose();
    }
  }, [request?.report?.reportDocument?.isSigned]);

  return (
    <MfDialog
      onClose={onClose}
      open={open}
      title="Подписание отчета об исполнении агентского поручения"
    >
      <SignAgentReportComponent request={request} />
    </MfDialog>
  );
};

export default SignAgentReportDialog;
